import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { Investor } from '../../shared/models/investor';
import { User } from '../../../core/user';

@Component({
  selector: 'app-investor-details',
  templateUrl: './investor-details.component.html',
  styleUrls: ['./investor-details.component.css'],
})
export class InvestorDetailsComponent implements OnInit, OnChanges {
  ageValue = 50;

  @Input() investor: Investor;
  @Input() flags: any;
  @Input() currentUserData: User;

  @Output() investorChange: EventEmitter<Investor>;

  //Error Strings
  nameError: String;
  emailError: String;
  phoneError: String;
  riskError: String;
  ageError: String;
  retAgeError: String;
  lifeExptError: String;
  dateError: String;
  taxError: String;

  constructor() {
    this.investorChange = new EventEmitter();
  }

  ngOnChanges() {
    this.investorChange.emit(this.investor);
  }

  validateBeforeExit() {
    // return true;
    if (!this.investor.name || this.investor.name.length < 2) {
      this.nameError = 'name must be at least 2 character long';
      return false;
    } else {
      this.nameError = null;
    }
    if (this.investor.name && this.investor.name.length > 32) {
      this.nameError = 'name must not be longer than 32 character long';
      return false;
    } else {
      this.nameError = null;
    }
    
    if (!this.investor.name || this.investor.name.length < 2) {
      this.nameError = 'name must be at least 2 character long';
      return false;
    }
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.investor.email ||
      this.investor.email.length < 2 ||
      !re.test(String(this.investor.email).toLowerCase())
    ) {
      this.emailError = 'Please enter a valid email address';
      return false;
    } else {
      this.emailError = null;
    }
    if(!this.investor.risk_category || this.investor.risk_category.length <=2){
      this.riskError = "Please select risk profile";
      return false;
    } else {
      this.riskError = null;
    }

    if( !this.investor.phone || this.investor.phone.toString().length != 10){
      this.phoneError = "phone number must be 10 character long";
      return false;
    } else {
      this.phoneError = null;
    }
    const today = new Date(); 
    if(today <= new Date(this.investor.DOB)){
      this.dateError = "Date of birth Invalid";
      return false;
    } else {
      this.dateError = null;
    }
    // if(!this.investor || this.investor.age <= 0){
    //   this.ageError = "Age cannot be zero";
    //   return false;
    // } else {
    //   this.ageError = null;
    // }
    if(!this.investor || this.investor.retirement_age == 0){
      this.retAgeError = "Retirement Age cannot be zero";
      return false;
    } else {
      this.retAgeError = null;
    }
    if(!this.investor || this.investor.life_expectancy == 0){
      this.lifeExptError = "Life Expectancy cannot be zero";
      return false;
    } else {
      this.lifeExptError = null;
    }
    if(!this.investor || (this.investor.life_expectancy < this.investor.retirement_age ) ) {
      this.lifeExptError = "Life Expectancy cannot be less than retirement Age";
      return false;
    } else {
      this.lifeExptError = null;
    }
    if(
      this.investor.tax_slab != 0 &&
      this.investor.tax_slab != 5 &&
      this.investor.tax_slab != 10 &&
      this.investor.tax_slab != 20 &&
      this.investor.tax_slab != 25 &&
      this.investor.tax_slab != 30
    ) {
    this.taxError = "Please set the tax rate";
    return false;
  } else {
    this.taxError = null;
  }
    return true;
  }

  ngOnInit() {}

  onAgeValueChange(age) {
    this.ageValue = age;
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\s\(\) ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  selectProfession(type) {
    this.investor.profession = type;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/investor-details/investor-details.component.ts